import React from 'react';
import { Box, Breadcrumbs, Link, Typography, Divider } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Link as RouterLink } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import BusinessIcon from '@mui/icons-material/Business';
import InventoryIcon from '@mui/icons-material/Inventory';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import BuildIcon from '@mui/icons-material/Build';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ApprovalIcon from '@mui/icons-material/Approval';
import DomainIcon from '@mui/icons-material/Domain';
import SettingsIcon from '@mui/icons-material/Settings';
import EventNoteIcon from '@mui/icons-material/EventNote';
import MenuIcon from '@mui/icons-material/Menu';
import FlagIcon from '@mui/icons-material/Flag';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import CampaignIcon from '@mui/icons-material/Campaign';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CreditScoreIcon from '@mui/icons-material/CreditScore';

const LinkRouter = (props) => <Link {...props} component={RouterLink} />;

const getTitleIcon = (icon) => {
  switch (icon) {
    case 'partner':
      return <BusinessIcon />;
    case 'product':
      return <InventoryIcon />;
    case 'order':
      return <AssignmentIcon />;
    case 'user':
      return <AccountCircleIcon />;
    case 'taxbill':
      return <ReceiptIcon />;
    case 'pay':
      return <ReceiptLongIcon />;
    case 'chance':
      return <AccountTreeIcon />;
    case 'tech':
      return <BuildIcon />;
    case 'dashboard':
      return <DashboardIcon />;
    case 'approval':
      return <ApprovalIcon />;
    case 'depart':
      return <DomainIcon />;
    case 'common':
      return <SettingsIcon />;
    case 'schedule':
      return <EventNoteIcon />;
    case 'menu':
      return <MenuIcon />;
    case 'goal':
      return <FlagIcon />;
    case 'statistics':
      return <AnalyticsIcon />;
    case 'warehouse':
      return <WarehouseIcon />;
    case 'notice':
      return <CampaignIcon />;
    case 'cost':
      return <PriceCheckIcon />;
    case 'bonds_dept':
      return <PriceCheckIcon />;
    case 'budget':
      return <CreditScoreIcon />;
    default:
      return '';
  }
};

// action: 페이지 우측 끝에 둘 버튼 하나(예: "신규 등록"). 기존 화면들은 넘기지 않으므로
// 안 넘기면 레이아웃이 그대로다(/chancemng 재배치용으로 2026-10-22 추가).
const BreadCrumbs = ({ pathnames, titlenames, icon, action }) => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: action ? 'space-between' : 'flex-start',
          alignItems: 'center',
          gap: 1,
          pb: 1,
          minWidth: 0,
          width: '100%',
        }}
      >
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{
            color: '#424242',
            minWidth: 0,
            '& .MuiBreadcrumbs-ol': {
              flexWrap: 'wrap',
              rowGap: 0.5,
            },
            '& .MuiTypography-root': {
              wordBreak: 'keep-all',
            },
          }}
          separator={<NavigateNextIcon fontSize="small" />}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <Box sx={{ fontSize: '0.875rem', mr: 1 }}>{getTitleIcon(icon)}</Box>
            <Typography variant="subtitle2">{titlenames[0]}</Typography>
          </Box>

          {/* <LinkRouter variant="subtitle2" underline="hover" color="inherit" to={`/${pathnames[0]}`}>
            {titlenames[1]}
          </LinkRouter> */}

          <Typography variant="subtitle2">{titlenames[1]}</Typography>
          {titlenames[2] && (
            <Typography variant="subtitle2">{titlenames[2]}</Typography>
          )}
        </Breadcrumbs>
        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Box>
      <Divider />
    </>
  );
};

export default BreadCrumbs;
